// extracted by mini-css-extract-plugin
export default {"buttons":"PopupButtons_buttons__kc3xY","button":"PopupButtons_button__sRQKI"};